module.exports = __webpack_public_path__ + "static/img/basecard.62463abb.jpg";